export const GLOBAL_EXPERIMENT_KEY = 'experiment-a';
export const PD_AVATARS_EXPERIMENT_KEY = 'personal-details-step-ab-with-avatars-vs-without';

// Reserved for future use of experiments
export const EXPERIMENT_VARIANTS = {
  [GLOBAL_EXPERIMENT_KEY]: {
    EXPERIMENT_VARIANT_A: 'control',
    EXPERIMENT_VARIANT_B: 'variant_b',
    EXPERIMENT_VARIANT_C: 'variant_c'
  },
  [PD_AVATARS_EXPERIMENT_KEY]: {
    EXPERIMENT_VARIANT_A: 'control',
    EXPERIMENT_VARIANT_B: 'pro_avatars'
  }
};
